import { Icon } from "@/react/components/shared/Icon";
import { IconContainer } from "./IconContainer";

interface StarsProps {
  color: string;
}

const starProperty = (color: string) => ({
  type: "16-star-fill",
  useWithFillCurrentColor: true,
  useWithStrokeCurrentColor: true,
  style: { color },
  className: "!h-4 !w-4",
});

export const Stars = ({ color }: StarsProps) => (
  <IconContainer dataTestId="testimonial-stars">
    <Icon {...starProperty(color)} />
    <Icon {...starProperty(color)} />
    <Icon {...starProperty(color)} />
    <Icon {...starProperty(color)} />
    <Icon {...starProperty(color)} />
  </IconContainer>
);
